var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFmcsaCompliance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M14.5 5.3c-.7 0-1.3-.6-1.3-1.3V1.2c0-.2.1-.4.2-.6.1-.1.3-.2.6-.2.4 0 .8.1 1.1.4l3 2.5c.4.3.6.8.6 1.3 0 .4-.3.7-.7.7zm-.3-3.9v2.7c0 .1.1.3.3.3h3.2c0-.1-.1-.2-.2-.2l-3-2.5c-.1-.2-.2-.2-.3-.3m-.2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M12.4 22h-8c-1.2 0-2.1-1-2.1-2.1V2.5c0-1.2 1-2.1 2.1-2.1h7.2V5c0 1 .8 1.8 1.8 1.8h5.4V14c0 .3-.2.5-.5.5s-.5-.2-.5-.5V7.8h-4.4c-1.5 0-2.8-1.3-2.8-2.8V1.4H4.4c-.6 0-1.1.5-1.1 1.1v17.3c0 .6.5 1.1 1.1 1.1h8c.3 0 .5.2.5.5s-.2.6-.5.6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M12.9 11.8h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5M14 15.8H9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5M6.7 15.8h-.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.8c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "m5.7 12.6-1.1-1.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l.3.3 1.2-1.4c.2-.2.5-.2.7 0s.2.5 0 .7z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M17.7 25.6c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6m0-11.1c-2.8 0-5 2.3-5 5s2.3 5 5 5 5-2.3 5-5-2.2-5-5-5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#10F18F",
  d: "M16.4 21.9c-.1 0-.3-.1-.4-.2l-1.2-1.4c-.2-.2-.2-.5 0-.7s.5-.2.7 0l.9 1 3.8-3.1c.2-.2.5-.1.7.1s.1.5-.1.7l-4.1 3.4c-.1.1-.2.2-.3.2"
})));
export default SvgFmcsaCompliance;